import axios from 'axios'
import { isEmpty, map } from 'lodash'
import { ACATS_SEARCH_API, WITH_CREDENTIALS_CONFIG } from './constants'
import { AcatsSearchDto } from './types'
import { parseJSON } from './jsonParser'

const getQueryParams = (acatsSearchDto: AcatsSearchDto) =>
  map(acatsSearchDto, (value, key) => {
    const urlEncodedValue = encodeURIComponent(`${value}`)
    return `acatsSearchDto.${key}=${urlEncodedValue}`
  }).join('&')

export const searchTransfers = (acatsSearchDto?: AcatsSearchDto) => {
  const searchUrl = isEmpty(acatsSearchDto)
    ? ACATS_SEARCH_API
    : `${ACATS_SEARCH_API}?${getQueryParams(acatsSearchDto!)}`

  // FEECM-17598: Use custom JSON parser to preserve acatControlNumber precision
  // The parseJSON function converts acatControlNumber from number to string before JSON.parse()
  // This prevents precision loss for 18-digit control numbers (JS Number max is 16 digits)
  return axios.get(searchUrl, {
    ...WITH_CREDENTIALS_CONFIG,
    transformResponse: [parseJSON]
  })
}
